module.exports = __webpack_public_path__ + "static/media/red-rake.995b3702.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/red-rake.jpg
// module id = 2403
// module chunks = 7